import {
  DocumentNode,
  NetworkStatus,
  OperationVariables,
  TypedDocumentNode,
  useQuery,
} from '@apollo/client'
import { strapiClient } from '../strapiApolloClient'

/**
 * Creates a query hook for Strapi GraphQL queries
 * @param query GraphQL query document (can include fragments)
 * @returns A hook function that executes the query with Apollo Client
 */
export function createStrapiQueryHook<TData, TVariables = OperationVariables>(
  query: DocumentNode | TypedDocumentNode<TData, TVariables>,
) {
  return (variables?: TVariables) => {
    const { data, loading, error, networkStatus } = useQuery<TData, TVariables>(
      query,
      {
        variables,
        client: strapiClient,
        fetchPolicy: 'cache-and-network',
        nextFetchPolicy: 'cache-first',
        notifyOnNetworkStatusChange: true,
      },
    )

    const isRefreshing =
      networkStatus === NetworkStatus.refetch ||
      networkStatus === NetworkStatus.poll ||
      networkStatus === NetworkStatus.fetchMore

    return {
      data: data || null,
      isLoading: loading && networkStatus === NetworkStatus.loading,
      isRefreshing,
      error: error || null,
    }
  }
}
